import {
  FaHtml5,
  FaCss3Alt,
  FaReact,
  FaNodeJs,
  FaGithub,
  FaPython, // Added
  FaLinux,  // Added
} from "react-icons/fa";
import { 
  TbBrandJavascript, 
  TbVectorBezier, 
  TbChartLine,
  TbBrandFramer // Added (Optional alternative)
} from "react-icons/tb";
import {
  SiMongodb,
  SiRedux,
  SiExpress,
  SiPrisma,
  SiVercel,
  SiJquery,
  SiTailwindcss,
  SiNextdotjs,
  SiMysql,
  SiGit,
  SiTypescript,
  SiKubernetes,
  SiAmazonaws,
  SiDocker,
  SiFirebase,
  SiSocketdotio,
  SiPostman,
  SiSwagger,
  SiGraphql,
  SiNginx,
  SiSupabase,
  SiOpenai,
  SiMui,            // Added
  SiNestjs,         // Added
  SiTerraform,      // Added
  SiGithubactions,  // Added
  SiMicrosoftazure, // Added
  SiPostgresql,     // Added
  SiRedis,           // Added (Optional for future)
  SiZod
} from "react-icons/si";
import "./Skills.css";

import { useMemo, useState } from "react";
import { Meteors } from "@stianlarsen/meteors";

const CATEGORIES = {
  frontend: {
    label: "Frontend",
    icon: <FaReact />,
    color: "#61dafb",
    items: [
      { name: "HTML5", icon: <FaHtml5 size={80} id="color" /> },
      { name: "CSS3", icon: <FaCss3Alt size={80} id="color" /> },
      { name: "JavaScript", icon: <TbBrandJavascript size={80} id="color" /> },
      { name: "TypeScript", icon: <SiTypescript size={80} id="color" /> },
      { name: "React", icon: <FaReact size={80} id="color" /> },
      { name: "Next.js", icon: <SiNextdotjs size={80} id="color" /> },
      { name: "Redux", icon: <SiRedux size={80} id="color" /> },
      { name: "Zod", icon: <SiZod size={80} id="color" /> },
      { name: "Tailwind CSS", icon: <SiTailwindcss size={80} id="color" /> },
      { name: "Material UI", icon: <SiMui size={80} id="color" /> }, // Replaced Shadcn
    ],
  },
  backend: {
    label: "Backend",
    icon: <FaNodeJs />,
    color: "#68a063",
    items: [
      { name: "Node.js", icon: <FaNodeJs size={80} id="color" /> },
      { name: "Express.js", icon: <SiExpress size={80} id="color" /> },
      { name: "NestJS", icon: <SiNestjs size={80} id="color" /> }, // Added
      { name: "Redis", icon: <SiRedis size={80} id="color" /> }, // Added
      { name: "Prisma", icon: <SiPrisma size={80} id="color" /> },
      { name: "Socket.IO", icon: <SiSocketdotio size={80} id="color" /> },
      { name: "GraphQL", icon: <SiGraphql size={80} id="color" /> },
      { name: "NGINX", icon: <SiNginx size={80} id="color" /> },
      { name: "Postman", icon: <SiPostman size={80} id="color" /> },
      { name: "Swagger", icon: <SiSwagger size={80} id="color" /> },
    ],
  },
  devops: {
    label: "DevOps",
    icon: <SiDocker />,
    color: "#2496ed",
    items: [
      { name: "Docker", icon: <SiDocker size={80} id="color" /> },
      { name: "Kubernetes", icon: <SiKubernetes size={80} id="color" /> },
      { name: "AWS", icon: <SiAmazonaws size={80} id="color" /> },
      { name: "Azure", icon: <SiMicrosoftazure size={80} id="color" /> }, // Added
      { name: "Terraform", icon: <SiTerraform size={80} id="color" /> }, // Added
      { name: "Linux", icon: <FaLinux size={80} id="color" /> }, // Added
      { name: "GitHub Actions", icon: <SiGithubactions size={80} id="color" /> }, // Added
      { name: "Git", icon: <SiGit size={80} id="color" /> },
      { name: "GitHub", icon: <FaGithub size={80} id="color" /> },
      { name: "Vercel", icon: <SiVercel size={80} id="color" /> },
    ],
  },
  ai: {
    label: "AI",
    icon: <SiOpenai />,
    color: "#10a37f",
    items: [
      { name: "OpenAI", icon: <SiOpenai size={80} id="color" /> },
      { name: "LangChain", icon: <TbVectorBezier size={80} id="color" /> },
      { name: "LangGraph", icon: <TbChartLine size={80} id="color" /> },
      { name: "RAG", icon: <TbVectorBezier size={80} id="color" /> },
        { name: "Python", icon: <FaPython size={80} id="color" /> },
    ],
  },
  database: {
    label: "Database",
    icon: <SiMongodb />,
    color: "#4db33d",
    items: [
      { name: "MongoDB", icon: <SiMongodb size={80} id="color" /> },
      { name: "MySQL", icon: <SiMysql size={80} id="color" /> },
      { name: "PostgreSQL", icon: <SiPostgresql size={80} id="color" /> }, // Added
      { name: "Supabase", icon: <SiSupabase size={80} id="color" /> },
      { name: "Vector DBs", icon: <TbVectorBezier size={80} id="color" /> },
    ],
  },
};

export default function Skills() {
  const [active, setActive] = useState("frontend");
  const tabs = useMemo(
    () => [
      { key: "frontend", ...CATEGORIES.frontend },
      { key: "backend", ...CATEGORIES.backend },
      { key: "devops", ...CATEGORIES.devops },
      { key: "ai", ...CATEGORIES.ai },
      { key: "database", ...CATEGORIES.database },
    ],
    []
  );

  return (
    <section className="section skills" id="skills" >
      <h2 className="section__title about_skills">Skills</h2>

      <div className="skills__tabs">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            className={`skills__tab ${active === t.key ? "is-active" : ""}`}
            onClick={() => setActive(t.key)}
            aria-pressed={active === t.key}
          >
            <span className="tab__icon" style={{ color: t.color }}>
              {t.icon}
            </span>
            <span className="tab__label">{t.label}</span>
          </button>
        ))}
      </div>

      <div id="container" className="skills__list" style={{position:"relative"}}>
        <Meteors
          speed={0.1}
          size={20}
          amount={10}
          colorLightmode="#2978b5"
          colorDarkmode="white"
          fallingSide="left"
        />

        {CATEGORIES[active].items.map((skill, index) => (
          <li key={index} className="skills__list-item">
            {skill.icon}
            <h5>{skill.name}</h5>
          </li>
        ))}
      </div>
    </section>
  );
}